<template>
    <div>
        <section class="bg-white">
            <div class="container">
                <div class="text-title">Account Dashboard</div>
                <div class="row q-col-gutter-md">
                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <q-card>
                            <q-item id="accountDetails" clickable v-ripple
                                    :active="form.selectedPage === 'account'"
                                    @click="form.selectedPage = 'account'"
                                    active-class="my-menu-link rounded-borders"
                                    class="rounded-borders full-height" style="border: 1px solid rgba(0, 0, 0, 0.12)">
                                <q-item-section avatar style="min-width: 0">
                                    <q-icon name="mdi-account" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="text-weight-medium">Account Details</q-item-label>
                                    <q-item-label class="text-caption">User information, password management</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-card>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <q-card>
                            <q-item clickable v-ripple bordered
                                    :active="form.selectedPage === 'licenses'"
                                    @click="form.selectedPage = 'licenses'"
                                    active-class="my-menu-link rounded-borders"
                                    class="rounded-borders full-height" style="border: 1px solid rgba(0, 0, 0, 0.12)">
                                <q-item-section avatar style="min-width: 0">
                                    <q-icon name="mdi-card-text" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="text-weight-medium">Licenses & Activations</q-item-label>
                                    <q-item-label class="text-caption">License management, activate, renew, upgrade</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-card>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <q-card>
                            <q-item clickable v-ripple bordered
                                    :active="form.selectedPage === 'orders'"
                                    @click="form.selectedPage = 'orders'"
                                    active-class="my-menu-link rounded-borders"
                                    class="rounded-borders full-height" style="border: 1px solid rgba(0, 0, 0, 0.12)">
                                <q-item-section avatar style="min-width: 0">
                                    <q-icon name="mdi-receipt" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label class="text-weight-medium">Orders</q-item-label>
                                    <q-item-label class="text-caption">Order history, details, receipts</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-card>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col">
                        <account-info v-if="form.selectedPage == 'account'" />
                        <account-licenses v-if="form.selectedPage == 'licenses'" />
                        <account-orders v-if="form.selectedPage == 'orders'" />
                    </div>
                </div>

                <dialog-subscription-reinstatement :show.sync="showReinstatementCostDialog"
                                                   :items="reinstatementLicenseItems" />
                <q-page-sticky v-if="cart.cartItems.length > 0" position="bottom-right" :offset="[18, 18]">
                    <q-btn fab icon="mdi-cart" color="primary" to="/store/cart" />
                </q-page-sticky>
            </div>
        </section>
    </div>
</template>
<script>
    import dialogSubscriptionReinstatement from '@/components/dialogs/DialogSubscriptionReinstatement'
    import accountInfo from '@/components/AccountInfo'
    import accountLicenses from '@/components/AccountLicenses'
    import accountOrders from '@/components/AccountOrders'
    import { mapState } from 'vuex'

    export default {
        name: 'my-account',
        props: {
            page: {
                default: 'account',
                type: String
            }
        },
        components: {
            accountInfo,
            accountLicenses,
            accountOrders,
            dialogSubscriptionReinstatement,
        },
        data() {
            return {
                form: {
                    selectedPage: this.page,
                }
            }
        },
        methods: {
            getAsyncData() {
                this.$store.dispatch('getCountries').then(() => {
                    this.countries = this.getCountriesData
                })
                this.$store.dispatch('getCanadianProvinces')
                this.$store.dispatch('getAmericanStates')
            },
            updateRoute(page) {
                this.$router.replace({
                    path: '/myaccount/' + page
                }).catch(err => { })
            },

        },
        computed: {
            ...mapState([
                'getLicensesCustomerData',
                'getLicensesCustomerPending',
            ]),
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            cart() { return this.$store.getters.cart },
            reinstatementLicenseItems() { return this.$store.getters.reinstatementLicenseItems },
            showReinstatementCostDialog() { return this.$store.getters.showReinstatementCostDialog },

            licenses() {
                if (this.getLicensesCustomerData) {

                    return this.getLicensesCustomerData?.filter(l => l.active)
                }
                return []
            },
        },
        created() {
            if (this.isLoggedIn) {
                this.getAsyncData()
            } else {
                this.$router.push('/').catch(err => { })
            }
        },
        watch: {
            'form.selectedPage'(newVal) {
                this.updateRoute(newVal)
            },
            '$route.query.page'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.form.selectedPage = newVal
                }
            },
        }

    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    .my-menu-link {
        color: white;
        font-weight: 500;
        background: $primary;
    }
</style>
